import FormConditionsEditor from '../../../components/FormConditionsEditor/FormConditionsEditor';

interface RequestFormSectionProps {
  contractTemplate: any;
  updateContractTemplate: (value: any) => void;
}

export default function RequestFormSection({ contractTemplate, updateContractTemplate }: RequestFormSectionProps) {
  const currentConditions: string[] = contractTemplate?.formConditions || [];

  return (
    <FormConditionsEditor
      conditions={currentConditions}
      onChange={(formConditions) => updateContractTemplate({ formConditions })}
    />
  );
}
